import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faRoad,
    faTree,
    faHamburger,
    faMoneyBillAlt
} from "@fortawesome/free-solid-svg-icons";
import Chart from "react-apexcharts";
import filterTypes from "data/filter-types";
import getDates from "helpers/getDates";
import getTreesFromMeters from "helpers/get-trees-from-meters";
import {
    actionFindStatistics,
    actionTaskTypes,
} from "actions/action/actions";

class UserStatistics extends React.Component {
    format = "YYYY-MM-DD";

    startDate = moment().subtract(1, "months").valueOf();

    endDate = moment().add(1, "days").valueOf();

    constructor(props) {
        super(props);

        this.state = {
            filters: [{
                fieldName: "user",
                fieldValue: this.props.userId,
                searchOperation: filterTypes.EQUALS.value
            }, {
                fieldName: "finished",
                fieldValue: [this.startDate, this.endDate],
                searchOperation: filterTypes.BETWEEN.value
            }, {
                fieldName: "task",
                fieldValue: 1,
                searchOperation: filterTypes.EQUALS.value
            }],
            page: 0,
            size: 100,
        };

        this.props.actionTaskTypes();
        this.props.actionFindStatistics(this.state.filters);
    }

    componentWillUnmount() {
        this.props.actionFindStatistics(false);
    }

    getCaloriesFromMeters = (meters) => {
        // 1000 m = 21 calories
        const oneMToCal = 0.021; //
        return (meters * oneMToCal).toFixed(2);
    };

    render() {
        const { actionStatistics } = this.props;

        const grouped = {};
        const totals = {
            distance: 0,
            amount: 0,
        };
        getDates(this.startDate, this.endDate).forEach(date => {
            if (!grouped[date]) {
                grouped[date] = {
                    distance: 0,
                    amount: 0,
                };
            }
        });

        actionStatistics.forEach(item => {
            totals.distance += item.distance;
            totals.amount += item.payment && item.payment.amount
                ? Math.round(item.payment.amount)
                : 0;

            const startDate = moment(item.started).format(this.format);
            if (!grouped[startDate]) {
                grouped[startDate] = {
                    distance: 0,
                    amount: 0,
                };
            }

            grouped[startDate].distance += item.distance;
            grouped[startDate].amount += item.payment && item.payment.amount
                ? Math.round(item.payment.amount)
                : 0;
        });

        return (
            <div className="h-100">
                <h1>{`${moment(this.startDate).format(this.format)} - ${moment(this.endDate).format(this.format)}`}</h1>
                <ul className="list-group list-group-horizontal mb-5" style={{ fontSize: 18 }}>
                    <li className="list-group-item active">
                        Totals
                    </li>
                    <li className="list-group-item">
                        <FontAwesomeIcon icon={faRoad} className="mr-2" />
                        Distance <b>{totals.distance}</b>
                    </li>
                    <li className="list-group-item">
                        <FontAwesomeIcon icon={faMoneyBillAlt} className="mr-2" />
                        Payment <b>{totals.amount}</b>
                    </li>
                    <li className="list-group-item">
                        <FontAwesomeIcon icon={faTree} className="mr-2" />
                        Tree <b>{getTreesFromMeters(totals.distance)}</b>
                    </li>
                    <li className="list-group-item">
                        <FontAwesomeIcon icon={faHamburger} className="mr-2" />
                        Calories <b>{this.getCaloriesFromMeters(totals.distance)}</b>
                    </li>
                </ul>
                <Chart
                    options={{
                        chart: {
                            id: "distance-bar",
                            toolbar: {
                                show: true
                            },
                            zoom: {
                                enabled: true,
                                type: "x",
                                autoScaleYaxis: false,
                                zoomedArea: {
                                    fill: {
                                        color: "#90CAF9",
                                        opacity: 0.4
                                    },
                                    stroke: {
                                        color: "#0D47A1",
                                        opacity: 0.4,
                                        width: 1
                                    }
                                }
                            }
                        },
                        title: {
                            text: "Distance",
                            align: "left"
                        },
                        plotOptions: {
                            bar: {
                                columnWidth: "50%",
                                endingShape: "arrow"
                            }
                        },
                        stroke: {
                            curve: "smooth"
                        },
                        xaxis: {
                            categories: Object.keys(grouped),
                            type: "datetime",
                        },
                        markers: {
                            size: 6,
                            strokeWidth: 3,
                            fillOpacity: 0,
                            strokeOpacity: 0,
                            hover: {
                                size: 8
                            }
                        },
                    }}
                    series={[{
                        name: "Distance",
                        type: "area",
                        data: Object.keys(grouped).map(day => grouped[day].distance)
                    }]}
                    type="line"
                    width="100%"
                    height={300}
                />

                <Chart
                    options={{
                        chart: {
                            id: "amount-bar",
                            toolbar: {
                                show: true
                            },
                            zoom: {
                                enabled: true,
                                type: "x",
                                autoScaleYaxis: false,
                                zoomedArea: {
                                    fill: {
                                        color: "#90CAF9",
                                        opacity: 0.4
                                    },
                                    stroke: {
                                        color: "#0D47A1",
                                        opacity: 0.4,
                                        width: 1
                                    }
                                }
                            }
                        },
                        title: {
                            text: "Amount",
                            align: "left"
                        },
                        plotOptions: {
                            bar: {
                                columnWidth: "50%",
                                endingShape: "arrow"
                            }
                        },
                        stroke: {
                            curve: "smooth",
                        },
                        xaxis: {
                            categories: Object.keys(grouped),
                            type: "datetime",
                        },
                        markers: {
                            size: 6,
                            strokeWidth: 3,
                            fillOpacity: 0,
                            strokeOpacity: 0,
                            hover: {
                                size: 8
                            }
                        },
                        colors: ["#7BD39A"],
                    }}
                    series={[{
                        name: "Amount",
                        type: "area",
                        data: Object.keys(grouped).map(day => grouped[day].amount)
                    }, /*
                    {
                        name: "Bonus",
                        type: "area",
                        data: Object.keys(grouped).map(day => grouped[day].bonus)
                    }
                    */]}
                    type="line"
                    width="100%"
                    height={300}
                />
            </div>
        );
    }
}

UserStatistics.propTypes = {
    userId: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
    taskTypes: state.action.taskTypes,
    paymentStatus: state.action.paymentStatus,
    actionStatistics: state.action.actionStatistics,
});

const mapStateToDispatch = dispatch => ({
    actionFindStatistics: bindActionCreators(actionFindStatistics, dispatch),
    actionTaskTypes: bindActionCreators(actionTaskTypes, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(UserStatistics);



// WEBPACK FOOTER //
// ./src/views/pages/users/user-statistics.js